import React from 'react';
import { findByText } from 'Common/Utils';
import { IntroNotice } from './IntroNotice';
import { ClickGesture } from 'Snippets/Redundancy';

export const AliasedRuleParameters = [
	{
		message: <IntroNotice />,
		find: 'a[data-chaperone-trigger]',
	},
	{
		message: (
			<>
				As you can see, We use only <b>FormWrapper</b> and <b>InputWithRules</b>{' '}
				from <b>Advance Design Pattern</b> section...
			</>
		),
		find(target) {
			return findByText(target, 'span:FormWrapper')[0];
		},
	},
	{
		message: (
			<>
				In this example we use the <b>required_if</b> rule as an example because
				it has 2 parameters. The normal usage of rule with parameter is like the
				rule below. The first parameter is the <b>gender</b> which is the{' '}
				<b>name</b> of target form field, And the second parameter is the <b>1</b>{' '}
				which is the requirement value of the target. if ever the requirement
				has met and the field <b>gender</b> has a value of <b>1</b>, Then
				it will be required...
			</>
		),
		find(target) {
			return findByText(target, 'span:required_if')[0];
		},
	},
	{
		message: (
			<>
				but remember when using <b>required_if</b> and <b>same</b> rules. the
				target field must be also registered to the schema even without rules related in it, to be able to check it's
				value...
			</>
		),
		find(target) {
			return findByText(target, 'span:formRegistry')[0];
		},
	},
	{
		message: (
			<>
				But if we do that. The parameter we put on rule will be put on the
				feedback...
			</>
		),
		find(target) {
			return target.querySelector('button');
		},
		allowNext: false,
		allowNextOnClick: true,
		gesture: <ClickGesture />,
		background: {
			backdropStyle: { opacity: 1 },
			highlightStyle: { backgroundColor: 'rgba(255,255,255, 1)' },
		},
	},
	{
		message: (
			<>
				As you read the message. the parameter we put on <b>required_if</b> is
				been put on the feedback which is vague for the users...
			</>
		),
		find(target) {
			return target.querySelector('.n-invalid-feedback');
		},
	},
	{
		message: (
			<>
				That is why we need an alias which in the user's view will understand.
				As you can see the rule below that we use symbol <b>@</b> to make an
				alias, so that the <b>gender</b> will be replace to <b>Gender</b>{' '}
				and <b>1</b> will be replace into <b>Male</b> so that the user will
				understand the feedback...
			</>
		),
		find(target) {
			return findByText(target, 'span:rules')[5];
		},
	},
	{
		message: <>As a result the user will now understand!</>,
		isDone: true,
		find(target) {
			return target.querySelectorAll('.n-invalid-feedback')[1];
		},
	},
];
